import type { App, Plugin } from 'vue';
import type { Router } from 'vue-router';
import {
  getConstant,
  type VixConstant,
  type VixRouteMap,
  type GetRouterOptions,
  type StorePlugin
} from '@koi-design/vix-auth';
import getRouter from './router';
import routeMap from './router/route.map';
import { config as defaultConfig, type ConfigType } from './config';

import Layout from './layout/Layout';
import LayoutFresh from './layoutFresh/Layout';
import hooks from './hooks';

export * from './export.type';

export { Layout, LayoutFresh, hooks };

type vixType = {
  getRouter: (
    routerMap: VixRouteMap | undefined,
    store: StorePlugin,
    option?: GetRouterOptions
  ) => Router;
  routeMap: VixRouteMap;
  getConstant: (prefix?: string) => VixConstant;
  init: (cfg: ConfigType) => void;
} & Plugin;

const init = (cfg?: Partial<ConfigType>) => {
  if (cfg?.PREFIX) {
    defaultConfig.PREFIX = cfg.PREFIX;
  }
  if (cfg?.LIST_DATA_PARAMETER) {
    defaultConfig.LIST_DATA_PARAMETER = cfg.LIST_DATA_PARAMETER;
  }
  if (cfg?.LIST_TOTAL_PARAMETER) {
    defaultConfig.LIST_TOTAL_PARAMETER = cfg.LIST_TOTAL_PARAMETER;
  }
  if (cfg?.CURRENT_PAGE_PARAMETER) {
    defaultConfig.CURRENT_PAGE_PARAMETER = cfg.CURRENT_PAGE_PARAMETER;
  }
  if (cfg?.PAGE_SIZE_PARAMETER) {
    defaultConfig.PAGE_SIZE_PARAMETER = cfg.PAGE_SIZE_PARAMETER;
  }
};

const install = (app: App, cfg?: Partial<ConfigType>) => {
  if (cfg) {
    init(cfg);
  }
};

const vix = {
  getRouter,
  routeMap,
  getConstant: (prefix = defaultConfig.PREFIX) => {
    return getConstant(prefix);
  },
  init,
  install
} as vixType;

export default vix;
